import { FC, PropsWithChildren } from 'react';

import styles from './LabelContainer.module.scss';

type Props = { className?: string; label: string; error?: string } & PropsWithChildren;

export const LabelContainer: FC<Props> = ({ className, children, label, error }) => {
	return (
		<div className={className}>
			<div className={styles.text}>{label}</div>
			{children}
			{error && <div className={styles.error}>{error}</div>}
		</div>
	);
};
